import styled from 'styled-components';

export const IndicatorsGrid = styled.div<{ gap?: string }>`
  display: grid;
  grid-template-columns: repeat(4, minmax(100px, auto));
  justify-content: space-between;
  gap: ${(props) => props.gap || 'var(--allie-spacing-xl)'};
`;

export const Container = styled.div<{ gap?: string, breakpoint?: string }>`
  display: flex;
  flex-direction: column;
  align-content: center;
  gap: var(--allie-spacing-md);
  height: 100%;
  justify-content: center;
  container: container-indicators / inline-size;

  @container container-indicators (max-width: ${(props) => props.breakpoint || '448px'}) {
    ${IndicatorsGrid} {
      grid-template-columns: repeat(2, 1fr);
      gap: ${(props) => props.gap || 'var(--allie-spacing-md)'};
    }
  }
`;

export const IndicatorCard = styled.div<{ showBorderCard?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 130px;
  padding: var(--allie-spacing-lg);
  border-radius: var(--allie-radius-md);
  box-sizing: border-box;
  border: ${(props) => (props.showBorderCard ? '1px solid var(--allie-color-neutral-20)' : 'none')};
  row-gap: var(--allie-spacing-md);
  background-color: var(--allie-color-white);

  span {
    font-size: 14px;
    color: var(--allie-color-neutral-60);
    margin-top: 8px;
  }

  .text-empty {
    font-size: 14px;
    font-weight: 600;
    fill: var(--allie-color-neutral-50);
    font-family: var(--ion-font-family);
  }
`; 